import styled from 'styled-components';
import { PH, poshubTableStyles } from './theme';

export const StyledCatalogTab = styled.div`
  font-size: ${PH.fontSizeBase};
  line-height: ${PH.lineHeightBody};
  color: ${PH.text};

  ${poshubTableStyles}

  .catalog-layout {
    display: flex;
    gap: 24px;
    min-height: 320px;
  }

  .catalog-sidebar {
    width: 200px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;

    .catalog-nav-item {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 11px 14px;
      text-align: left;
      border: none;
      border-radius: 4px;
      background: transparent;
      font-size: ${PH.fontSizeBase};
      font-weight: 500;
      color: ${PH.text};
      cursor: pointer;
      transition: background 0.15s ease, color 0.15s ease;

      .anticon {
        font-size: 16px;
        color: ${PH.textMuted};
      }

      &:hover {
        background: ${PH.surfaceMuted};
        .anticon {
          color: ${PH.text};
        }
      }

      &.active {
        background: rgba(0, 0, 0, 0.04);
        color: ${PH.primary};
        font-weight: 600;
        box-shadow: inset 3px 0 0 ${PH.primary};

        .anticon {
          color: ${PH.primary};
        }
      }
    }
  }

  .catalog-main {
    flex: 1;
    min-width: 0;

    .catalog-section-title {
      font-weight: 700;
      font-size: ${PH.fontSizeSection};
      line-height: 24px;
      margin-bottom: 14px;
      color: ${PH.text};
      letter-spacing: -0.01em;
    }
  }

  .poshub-catalog-descriptions {
    .ant-descriptions-item-label {
      font-size: ${PH.fontSizeSm};
      font-weight: 600;
      color: ${PH.textLabel};
      width: 38%;
    }

    .ant-descriptions-item-content {
      font-size: ${PH.fontSizeBase};
      color: ${PH.text};
    }
  }

  .poshub-catalog-drawer {
    .ant-drawer-header-title {
      flex-direction: row-reverse;
    }

    .ant-drawer-title {
      font-size: ${PH.fontSizeTitle};
      font-weight: 700;
      color: ${PH.text};
    }
  }
`;
